import React, { useContext, useEffect, useState } from "react";
import { Box, Button, Checkbox, CircularProgress, Dialog, DialogContent, FormControl, FormControlLabel, FormGroup, IconButton, InputLabel, MenuItem, Select, TextField, Typography, Fab, DialogActions, Tabs, Tab, Autocomplete, CardContent, Card, Modal } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { Check as CheckIcon, Clear as ClearIcon, Close, CropSharp, Details } from "@mui/icons-material";
import { CloseOutlined } from "@mui/icons-material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CloseIcon from '@mui/icons-material/Close';
import { Stack } from "@mui/material";
import styled from "styled-components";
import OpaqueLoading from "../opaqueLoading/opaqueLoading";
import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton, getGridStringOperators } from "@mui/x-data-grid";
import { AuthContext } from "../contextAPI/ContextAPI";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import searchIcon from "../../icons/searchIcon.svg";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from "dayjs";
const isMobile = window.innerWidth < 900;
const TotalAmountTypography = styled(Typography)`
  position: absolute;
  bottom: 10px;
  right: 10px;
  font-size: ${isMobile ? "14px" : "inherit"};
  bottom: ${isMobile ? "85px" : "70px"};
  right: ${isMobile ? "15px" : "70px"};
`;
const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px;
`;
const TableContainer = styled.div`
  // height: calc(
  //   100vh - ${isMobile ? "106px - 20px - 82.23px" : "100px - 20px - 23.77px"}
  // );
  width: ${isMobile ? "100%" : "98%"};
  // border: solid 1px lightGrey;
  border-radius: 8px;
  margin-left:${isMobile ? "0px" : "10px"};
  margin-bottom:${isMobile ? "0px" : "10px"};

`;
const TabsContainer = styled.div`
  ${isMobile && `
    height: calc(100vh - 176px - 20px - 43.77px);
  `}
`
const StyledTabs = styled(Tabs)`
  border-bottom: solid 1px lightGrey;
`;

const TodayVisitModal = ({ onClose, is_download }) => {
    const [tabValue, setTabValue] = useState(0);
    const [loading, setLoading] = useState(false);
    const [dataGrid, setDataGrid] = useState([]);
    const [rowCount, setRowCount] = useState();
    const [endVisitRow, setEndVisitRow] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [endVisitModalOpen, setEndVisitModalOpen] = useState(false);
    const [newOrderStatus, setNewOrderStatus] = useState("");
    const [visitModalData, setVisitModalData] = useState({});
    const [questionCategories, setQuestionCategories] = useState([]);
    const [openVisitViewModal, setOpenVisitViewModal] = useState(false);
    const [paginationModel, setPaginationModel] = useState({
        page: currentPage - 1,
        pageSize: 20,
    });
    const [visitOutcomes, setVisitOutcomes] = useState([]);
    const [accessChanges, setAccessChanges] = useState([]);
    const [imageModalOpen, setImageModalOpen] = useState(false);
    const [visitTypes, setVisitTypes] = useState([])
    const [imageUrl, setImageUrl] = useState("");
    const [endVisitForm, setEndVisitForm] = useState({
        startMeetingTime: "",
        endMeetingTime: "",
        endVisitTime: "",
        remark: "",
        mobileNumber: "",
        contactName: "",
        statusOfVisit: "",
        workDone: "",
        productCategory: [],
        feedback: "",
        visitOutcome: ""
    });
    const [errors, setErrors] = useState({
        remark: false,
        followUpDate: false,
        followUpRemark: false,
    });
    const [meetingHappened, setMeetingHappened] = useState("")
    const [statusWork, setStatusWork] = useState([])
    const [workDone, setWorkDone] = useState([])
    const [feedback, setFeedback] = useState([])
    const [rm, setRm] = useState("")
    const [rsm, setRsm] = useState("")
    const [asm, setAsm] = useState("")
    const [rsms, setRsms] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [isFollowUpRequired, setIsFollowUpRequired] = useState(false);
    const [asms, setAsms] = useState([]);
    const [rms, setRms] = useState([]);
    const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)
    const [followUpDateIsReq, setFollowUpDateIsReq] = useState("")
    const [followUpRemarkIsReq, setIsFollowUpRemarkIsReq] = useState("")
    const [nextStepTrue, setNextStepTrue] = useState("");
    const [visitEndRemark, setVisitEndRemark] = useState("");

    // Track if user has performed a search or status/pagination change
    const [hasSearched, setHasSearched] = useState(false);

    // Only call getTodayVisits when hasSearched is true
    useEffect(() => {
        if (hasSearched) {
            // setLoading(true);
            getTodayVisits();
        }
    }, [paginationModel.page, paginationModel.pageSize, newOrderStatus]);

    useEffect(() => {
        if (endVisitModalOpen && endVisitRow?.meeting_with_decision_maker) {
            setMeetingHappened(endVisitRow.meeting_with_decision_maker.toLowerCase());
        } else if (endVisitModalOpen && endVisitRow?.meeting_with_decision_maker == "" || endVisitModalOpen && endVisitRow?.meeting_with_decision_maker == null) {
            setMeetingHappened("");
        }
    }, [endVisitModalOpen, endVisitRow?.meeting_with_decision_maker]);

    const handleChangeTab = (event, newValue) => {
        setTabValue(newValue);
    };

    useEffect(() => {
        getStatusOfVisit();
        getVisitOutcomes();
        getWorkDone();
        getFeedback();
        getVisitType();
        if (userData?.role.toLowerCase().includes('admin')) {
            getAllUsers()
        }
        if (userData?.role == 'rsm') {
            getUsers('rsm', userData?.id)
        }
        if (userData?.role == 'asm') {
            getUsers('asm', userData?.id)
        }
    }, [])

    const getVisitType = async () => {
        let results = await window.Platform.database.getRouteVisitType();
        setVisitTypes(results.data)
    }

    console.log(endVisitRow, "endVisitRowendVisitRow")
    async function getAllUsers() {
        let results = await window.Platform.database.fetchEmployees()
        setAllUsers(results?.data)
        setRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
        setRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
        setAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
    }

    const getStatusOfVisit = async () => {
        try {
            const results = await window.Platform.database.getStatusType({});
            setStatusWork(results.data)
        }
        catch (err) {
            console.log(err)
        }
    }

    const getWorkDone = async () => {
        let results = await window.Platform.database.getWorkDone();
        setWorkDone(results.data)
    }
    const getFeedback = async () => {
        let results = await window.Platform.database.getFeedback();
        setFeedback(results.data)
    }

    const exportOrders = async () => {
        setLoading(true);
        try {
            const today = new Date();
            const yyyy = today.getFullYear();
            const mm = String(today.getMonth() + 1).padStart(2, '0');
            const dd = String(today.getDate()).padStart(2, '0');
            const todayStr = `${yyyy}-${mm}-${dd}`;


            let data = {
                // asm: asm,
                // rsm: rsm,
                asm: userData?.role === 'asm' ? userData?.id : asm,
                rsm: userData?.role === 'rsm' ? userData?.id : rsm,
                ownerName: rm,
                startDate: todayStr,
                endDate: todayStr,
            }
            let result = await window.Platform.database.exportData("/visit/downloadVisitExcel",
                data
            )
            const blob = new Blob([result.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const now = new Date();
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${formattedDate}_VisitReport.xlsx`);
            // link.setAttribute("download", "visit.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error("Export error:", error);
        }
    }

    async function getUsers(role, id) {
        if (id != "") {
            let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
            if (role == 'rsm') {
                setAsms(results?.data)
                setRms(results?.data1)
            }
            if (role == 'asm') {
                setRms(results?.data)
            }
        } else {
            if (role == 'rsm') {
                setRm("")
                setAsm("")
                setRms(allUsers?.filter((ele) => ele.role == 'se'))
                setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
            }
            if (role == 'asm') {
                setRm("")
                setRms(allUsers?.filter((ele) => ele.role == 'se'))
            }
        }
    }

    const getTodayVisits = async () => {
        setLoading(true);
        try {
            const today = new Date();
            const yyyy = today.getFullYear();
            const mm = String(today.getMonth() + 1).padStart(2, '0');
            const dd = String(today.getDate()).padStart(2, '0');
            const todayStr = `${yyyy}-${mm}-${dd}`;

            let payload = {
                pageNumber: paginationModel.page || 0,
                recordPerPage: paginationModel.pageSize || 20,
                ownerName: rm || "",
                rsm: userData?.role === 'rsm' ? userData?.id : rsm || "",
                asm: userData?.role === 'asm' ? userData?.id : asm || "",
                startDate: todayStr,
                endDate: todayStr,
                status: "",
                partyType: "",
                visitType: "",
                visitOutcome: "",
                otp_verified: "",
                visitStatus: newOrderStatus === 1 ? "visit_start" : newOrderStatus === 2 ? "meeting_start" : newOrderStatus === 3 ? "meeting_end" : newOrderStatus === 4 ? "visit_end" : ""
            };
            let results = await window.Platform.database.fetchAllVisit(payload);
            if (results?.status === false) {
                setRowCount(results.data1 || 0);
                const jsonArrayWithId = (results?.data || []).map((obj, index) => ({ ...obj, idIndex: index + 1 }));
                setAccessChanges(jsonArrayWithId);
                setLoading(false);
            } else {
                window.NotificationUtils.showError(results?.message || "Error Fetching Data");
                setLoading(false);
            }
        } catch (error) {
            console.error(error);
            window.NotificationUtils.showError("Something Went Wrong");
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    const handleOpenVisitModal = async (rowData) => {
        setLoading(true);
        try {
            const result = await window.Platform.database.fetchVisitById({ visitId: rowData.visitId });
            if (result?.status === false && result.data) {
                setVisitModalData(result.data);
                setOpenVisitViewModal(true);
                getQuestionCategory();
            } else {
                window.NotificationUtils.showError("Could not fetch visit details");
            }
        } catch (error) {
            window.NotificationUtils.showError("Error fetching visit details");
        } finally {
            setLoading(false);
        }
    };

    const getQuestionCategory = async () => {
        try {
            setLoading(true);
            let result = await window.Platform.database.getQuestionCategory({});
            if (result?.status && Array.isArray(result.data)) {
                setQuestionCategories(result.data);
            }
            console.log("Question categories:", result);
        } catch (error) {
            console.error("Error fetching question categories", error);
            window.NotificationUtils.showError("Error fetching question categories");
        } finally {
            // setLoading(false);
        }
    };

    const handleCloseVisitViewModal = () => {
        setOpenVisitViewModal(false);
        setVisitModalData({})
    };

    const showImages = (pictures) => {
        const url = window.Platform.database.funcForBaseURL() + "/file" + pictures;
        setImageUrl(url);
        setImageModalOpen(true);
    }
    const endVisitDirect = async (rowData) => {
        // console.log("Row data for end visit:", rowData);
        setEndVisitRow(rowData);
        setEndVisitForm({
            startMeetingTime: rowData?.start_time_meeting || "",
            endMeetingTime: rowData?.end_time_meeting || "",
            endVisitTime: rowData?.endTime || "",
            remark: "",
            mobileNumber: "",
            contactName: "",
            statusOfVisit: "",
            workDone: "",
            productCategory: [],
            feedback: "",
            visitOutcome: ""
        });
        setEndVisitModalOpen(true);
        getTodayVisits();
    }
    const openPackaging = (val) => {
        const url = window.Platform.database.funcForBaseURL() + "/file" + val;
        setImageUrl(url);
        setImageModalOpen(true);
    };

    const getVisitOutcomes = async () => {
        try {
            setLoading(true);
            let results = await window.Platform.database.getVisitOutcomes();
            setVisitOutcomes(results.data);
            // const jsonArrayWithId = results?.data?.map((obj, index) => ({
            //   ...obj,
            //   id: index + 1,
            // }));
            // setAccessChanges(jsonArrayWithId);
            setLoading(false);
        } catch (error) {
            window.NotificationUtils.showError("Error Fetching Data");
            setLoading(false);
        }
    }

    const updateMeetingWithDecisionMaker = () => async () => {
        setLoading(true);
        const payload = {
            visitId: endVisitRow?.visitId,
            meeting_with_decision_maker: meetingHappened,
        };
        const result = await window.Platform.database.updateMeetingWithDecisionMaker(payload);
        if (result?.status) {
            window.NotificationUtils.showSuccess(result?.message);
            setMeetingHappened((result?.meeting_with_decision_maker)?.toLowerCase())
            setNextStepTrue((result?.meeting_with_decision_maker)?.toLowerCase())
            setEndVisitRow(prev =>
                prev && prev.visitId === payload.visitId
                    ? { ...prev, meeting_with_decision_maker: result?.meeting_with_decision_maker }
                    : prev
            );
            setLoading(false);
        }
        else {
            window.NotificationUtils.showError(result?.message);
            setLoading(false);
        }
    }

    const handleEndVisitSubmit = async () => {
        let hasError = false;
        let newErrors = { ...errors };
        if (endVisitRow?.meeting_with_decision_maker == "no") {
            if (isFollowUpRequired) {
                if (!followUpDateIsReq) {
                    newErrors.followUpDateIsReq = true;
                    hasError = true;
                }
                else {
                    newErrors.followUpDateIsReq = false;
                }
                if (!followUpRemarkIsReq) {
                    newErrors.followUpRemarkIsReq = true;
                    hasError = true;
                } else {
                    newErrors.followUpRemarkIsReq = false;
                }
            }
            // if (!visitEndRemark) {
            //     newErrors.visitEndRemark = true;
            //     hasError = true;
            // }
            // else {
            //     newErrors.visitEndRemark = false;
            // }
        }
        if (!visitEndRemark) {
            newErrors.visitEndRemark = true;
            hasError = true;
        }
        else {
            newErrors.visitEndRemark = false;
        }
        console.log(endVisitRow?.meeting_with_decision_maker, "endVisitRow?.meeting_with_decision_maker")
        if (endVisitRow?.meeting_with_decision_maker && endVisitRow?.meeting_with_decision_maker?.toLowerCase() == "yes") {
            if (!endVisitForm.remark || endVisitForm.remark.trim() === "") {
                newErrors.remark = true;
                hasError = true;
            } else {
                newErrors.remark = false;
            }
            if (endVisitForm?.visitOutcome === "FpPIgxcOrY") {
                if (!endVisitForm.followUpDate) {
                    newErrors.followUpDate = true;
                    hasError = true;
                } else {
                    newErrors.followUpDate = false;
                }
                if (!endVisitForm.followUpRemark || endVisitForm.followUpRemark.trim() === "") {
                    newErrors.followUpRemark = true;
                    hasError = true;
                } else {
                    newErrors.followUpRemark = false;
                }
            } else {
                newErrors.followUpDate = false;
                newErrors.followUpRemark = false;
            }

        }
        setErrors(newErrors);
        if (hasError) return;

        // Determine partyType: 0 for distributor, 1 for school
        let partyType = null;
        if (endVisitRow?.DistributorName) {
            partyType = 0;
        } else if (endVisitRow?.schoolName) {
            partyType = 1;
        }

        // Use followUpDate from endVisitForm, convert to epoch if valid
        let followUpDateEpoch = undefined;
        if (endVisitForm.followUpDate) {
            const dateObj = new Date(endVisitForm.followUpDate);
            if (!isNaN(dateObj.getTime())) {
                followUpDateEpoch = Math.floor(dateObj.getTime() / 1000);
            }
        }
        if (followUpDateIsReq) {
            const dateObj = new Date(followUpDateIsReq);
            if (!isNaN(dateObj.getTime())) {
                followUpDateEpoch = Math.floor(dateObj.getTime() / 1000);
            }
        }

        const payload = {
            ...endVisitForm,
            visitId: endVisitRow?.visitId,
            partyId: endVisitRow?.partyId,
            partyType: partyType,
            ownerId: endVisitRow?.ownerId,
            followUpDate: followUpDateEpoch,
            followUpRemark: followUpRemarkIsReq || endVisitForm.followUpRemark,
            vistEndRemark: visitEndRemark,
            decisionMaker: endVisitRow?.meeting_with_decision_maker,
            visitedStatus: endVisitRow?.visited_status
        };

        // console.log("Payload to submit:", payload, "endVisitRow", endVisitRow);
        // return;
        const result = await window.Platform.database.endVisitByWeb(payload);
        if (result?.status) {
            window.NotificationUtils.showError(result?.message);

        }
        else {
            setEndVisitModalOpen(false);
            window.NotificationUtils.showSuccess(result?.message);
            setEndVisitForm({
                startMeetingTime: "",
                endMeetingTime: "",
                endVisitTime: "",
                remark: "",
                mobileNumber: "",
                contactName: "",
                statusOfVisit: "",
                workDone: "",
                productCategory: [],
                feedback: "",
                visitOutcome: "",
                followUpDate: "",
                followUpRemark: "",
            });
            setErrors({ remark: false, followUpDate: false, followUpRemark: false });
            getTodayVisits();
            setNewOrderStatus(4);
            setVisitEndRemark("");
        }
    };

    const handleEndVisitFormChange = (e) => {
        const { name, value } = e.target;
        setEndVisitForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleStartMeetingChange = (newValue) => {
        setEndVisitForm((prev) => ({
            ...prev,
            startMeetingTime: newValue ? newValue.toISOString() : "",
        }));
    };


    const renderContent1 = () => {
        return (
            <>
                {/* <Stack direction={"row"} spacing={2} padding={2}> */}

                <div className="row mt-2 mb-2 ml-2">

                    <Button
                        onClick={() => {
                            setNewOrderStatus("");
                            setHasSearched(true);
                        }}
                        style={{ backgroundColor: newOrderStatus === "" ? "#8787f470" : "white", color: newOrderStatus === "" ? "black" : "black", fontWeight: "500", }}>
                        All
                    </Button>
                    <Button
                        onClick={() => {
                            setNewOrderStatus(1);
                            setHasSearched(true);
                        }}
                        style={{ backgroundColor: newOrderStatus === 1 ? "#D09F39" : "white", color: newOrderStatus === 1 ? "white" : "black", fontWeight: "500", }}>
                        Visit Started
                    </Button>
                    <Button
                        onClick={() => {
                            setNewOrderStatus(2);
                            setHasSearched(true);
                        }}
                        style={{ backgroundColor: newOrderStatus === 2 ? "#61d2ff" : "white", color: newOrderStatus === 2 ? "black" : "black", fontWeight: "500", }}>
                        Meeting Started
                    </Button>
                    <Button
                        onClick={() => {
                            setNewOrderStatus(3);
                            setHasSearched(true);
                        }}
                        style={{ backgroundColor: newOrderStatus === 3 ? "#f05dc3" : "white", color: newOrderStatus === 3 ? "black" : "black", fontWeight: "500", }}>
                        Meeting Ended
                    </Button>
                    <Button
                        onClick={() => {
                            setNewOrderStatus(4);
                            setHasSearched(true);
                        }}
                        style={{ backgroundColor: newOrderStatus === 4 ? "green" : "white", color: newOrderStatus === 4 ? "white" : "black", fontWeight: "500", }}>
                        Visit Completed
                    </Button>
                    <Typography variant="body1" className="ml-4 mt-2" sx={{ fontSize: "14px", fontWeight: "500", color: "black" }}>Select Page Size:&nbsp; </Typography>
                    <Select
                        value={paginationModel.pageSize}
                        variant="outlined"
                        size="small"
                        onChange={(e) => {
                            setPaginationModel({ ...paginationModel, pageSize: e.target.value });
                            setHasSearched(true);
                        }}
                        sx={{ width: 90, fontSize: "14px", fontWeight: "500", color: "black" }}
                    >
                        {[10, 20, 30, 50, 100].map((role) => (
                            <MenuItem key={role} value={role} sx={{ fontSize: "14px", fontWeight: "500", color: "black" }}>{role}</MenuItem>
                        ))}
                    </Select>
                </div>

                {/* </Stack> */}
                <Stack direction={"column"} spacing={2} padding={0} width={"100%"}>

                    {(!dataGrid || dataGrid.length === 0) ? (
                        <Typography align="center" color="text.secondary" sx={{ py: 5 }}>
                            <b style={{ fontSize: "14px", color: "black", fontWeight: "500" }}>No data found</b>
                        </Typography>
                    )
                        : (
                            <DataGrid
                                className="payrollGrid"
                                style={{ height: !dataGrid.length ? '200px' : 'auto' }}
                                density="compact"
                                rows={dataGrid || []}
                                columns={getColumns()}
                                sx={{ color: "black", fontSize: "12px", fontWeight: "600" }}
                                rowHeight={60}
                                disableSelectionOnClick
                                disableDensitySelector
                                disableRowSelectionOnClick
                                // initialState={{
                                //     pagination: {
                                //         paginationModel: {
                                //             pageSize: 10,
                                //         },
                                //     },
                                // }}
                                pageSizeOptions={[10]}
                                rowCount={rowCount}
                                paginationModel={paginationModel}
                                paginationMode="server"
                                onPaginationModelChange={setPaginationModel}
                            />
                        )}
                </Stack>
            </>
        )
    }

    useEffect(() => {
        setDataGrid(accessChanges.map((row, idx) => ({
            id: row.visitId || idx + 1,
            visitId: row.visitId,
            u_name: row.u_name,
            schoolName: row.schoolName,
            DistributorName: row.DistributorName,
            typeName: row.typeName,
            visited_status: row.visited_status,
            startTime: row.startTime,
            endTime: row.endTime,
            start_time_meeting: row.start_time_meeting,
            end_time_meeting: row.end_time_meeting,
            start_address: row.start_address,
            end_address: row.end_address,
            start_image: row.start_image,
            end_image: row.end_image,
            otp_verified: row.otp_verified,
            otp_number: row.otp_number,
            ownerId: row.ownerId,
            partyId: row.partyId,
            meeting_with_decision_maker: row.meeting_with_decision_maker
        })));
    }, [accessChanges]);

    const getColumns = () => {
        const stringOperators = getGridStringOperators().filter((op => ['contains'].includes(op.value)));
        return [
            {
                field: "partyNamqq1e",
                headerName: "Party ID",
                sortable: false,
                width: 150,
                filterOperators: stringOperators,
                editable: false,
                valueGetter: (params) => {
                    return (params.row.partyId || "N/A");
                },
                renderCell: (params) => {
                    let name = params.row.partyId || "N/A"
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "partyName",
                headerName: "Party Name",
                sortable: false,
                width: 350,
                filterOperators: stringOperators,
                editable: false,
                valueGetter: (params) => {
                    return (params.row.schoolName || params.row.DistributorName || "N/A");
                },
                renderCell: (params) => {
                    let name = params.row.schoolName || params.row.DistributorName || "N/A"
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "visit done name",
                headerName: "Visit Done By",
                width: 200,
                sortable: false,
                filterOperators: stringOperators,
                valueGetter: (params) => {
                    return (params.row.u_name || "N/A");
                },
                renderCell: (params) => {
                    let name = params.row?.u_name || "N/A"
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "VisitType",
                headerName: "Visit Type",
                width: 150,
                sortable: false,
                filterable: false,
                valueGetter: (params) => {
                    return (params.row.typeName || "N/A");
                },
                renderCell: (params) => {
                    // let name = params.row?.typeName || "N/A"
                    let name = visitTypes?.find(
                        (ele) => ele?.routeVisitTypeID === params.row.typeName
                    )?.routeVisitType || "N/A";

                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "Status",
                headerName: "Visit Status",
                width: 150,
                filterable: false,
                sortable: false,
                valueGetter: (params) => {
                    return (params.row.visited_status == 1 ? "Visit Started" : params.row.visited_status == 2 ? "Meeting Started" : params.row.visited_status == 3 ? "Meeting Ended" : params.row.visited_status == 4 ? "Visit Completed" : "N/A" || "N/A");
                },
                renderCell: (params) => {
                    let name = params.row.visited_status == 1 ? "Visit Started" : params.row.visited_status == 2 ? "Meeting Started" : params.row.visited_status == 3 ? "Meeting Ended" : params.row.visited_status == 4 ? "Visit Completed" : "N/A" || "N/A"
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "Date",
                headerName: "Date",
                width: 150,
                filterable: false,
                sortable: false,
                valueGetter: (params) => {
                    const dateStr = params.row.startTime;
                    if (!dateStr) return "N/A";
                    const dateObj = new Date(dateStr);
                    if (isNaN(dateObj.getTime())) return "N/A";
                    // Format: 15 Jun 2025
                    const day = String(dateObj.getDate()).padStart(2, '0');
                    const month = dateObj.toLocaleString('en-US', { month: 'short' });
                    const year = dateObj.getFullYear();
                    return `${day} ${month} ${year}`;
                },
                renderCell: (params) => {
                    const dateStr = params.row?.startTime;
                    if (!dateStr) return <Tooltip title="N/A"><Typography variant="inherit">N/A</Typography></Tooltip>;
                    const dateObj = new Date(dateStr);
                    if (isNaN(dateObj.getTime())) return <Tooltip title="N/A"><Typography variant="inherit">N/A</Typography></Tooltip>;
                    const day = String(dateObj.getDate()).padStart(2, '0');
                    const month = dateObj.toLocaleString('en-US', { month: 'short' });
                    const year = dateObj.getFullYear();
                    const formatted = `${day} ${month} ${year}`;
                    return (
                        <Tooltip title={formatted}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{formatted}</Typography>
                        </Tooltip>
                    );
                },
            },
            {
                field: "View",
                headerName: "View",
                minWidth: 100,
                filterable: false,
                sortable: false,
                renderCell: (params) => {
                    return (
                        <>
                            <Tooltip>
                                <span>
                                    <Button
                                        variant="contained"
                                        size="small"
                                        onClick={() => handleOpenVisitModal(params.row)}
                                        sx={{ minWidth: "80px" }}
                                    >
                                        {"View"}
                                    </Button>
                                </span>
                            </Tooltip>
                            <Modal open={openVisitViewModal} onClose={handleCloseVisitViewModal}>
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "80%",
                                        maxWidth: 900,
                                        bgcolor: "white",
                                        boxShadow: 24,
                                        p: 4,
                                        borderRadius: 2,
                                        maxHeight: "90%",
                                        overflowY: "auto",
                                    }}
                                >
                                    <Typography variant="h6" component="h2" style={{ textAlign: "center" }} sx={{ color: "black", fontSize: "16px", fontWeight: "600" }}>
                                        Visit Details
                                    </Typography>
                                    <IconButton onClick={() => setOpenVisitViewModal(false)} style={{ position: "absolute", top: 10, right: 10 }}>
                                        <CloseOutlined />
                                    </IconButton>
                                    {/* <hr style={{ width: "100%", color:"black", fontWeight:"800" }} /> */}
                                    <hr style={{ width: "100%", border: "none", borderTop: "2px solid #222", margin: "16px 0" }} />
                                    <div>
                                        <div className="row mb-2">
                                            <div className="col-md-6">
                                                <b style={{ color: "black" }}> Party Id : </b> <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{visitModalData[0]?.partyId || "N/A"}</span>
                                            </div>
                                            <div className="col-md-6">
                                                <b style={{ color: "black" }}> Party Name :</b> <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}> {visitModalData[0]?.schoolName ? visitModalData[0]?.schoolName : visitModalData[0]?.DistributorName || "N/A" || "N/A"} </span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-md-6">
                                                {/* <b style={{color:"black"}}>Visit Start Time : </b> {visitModalData[0]?.startTime || "N/A"} */}
                                                <b style={{ color: "black" }}>Visit Start Time : </b>
                                                <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{visitModalData[0]?.startTime
                                                    ? new Date(visitModalData[0].startTime).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })
                                                    : "N/A"} </span>
                                            </div>
                                            <div className="col-md-6">
                                                <b style={{ color: "black" }}>Meeting Start Time : </b>
                                                {/* {visitModalData[0]?.start_time_meeting || "N/A"} */}
                                                <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{visitModalData[0]?.start_time_meeting
                                                    ? new Date(visitModalData[0].start_time_meeting).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })
                                                    : "N/A"}</span>
                                            </div>

                                        </div>
                                        <div className="row mb-2">

                                            <div className="col-md-6">
                                                <b style={{ color: "black" }}>MeetingEnd Tiime :</b>
                                                {/* {visitModalData[0]?.end_time_meeting || "N/A"} */}
                                                <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}> {visitModalData[0]?.end_time_meeting
                                                    ? new Date(visitModalData[0].end_time_meeting).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })
                                                    : "N/A"}</span>
                                            </div>
                                            <div className="col-md-6">
                                                <b style={{ color: "black" }}>Visit End Time :</b>
                                                {/* {visitModalData[0]?.endTime || "N/A"} */}
                                                <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}> {visitModalData[0]?.endTime
                                                    ? new Date(visitModalData[0].endTime).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })
                                                    : "N/A"}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-md-6">
                                                <b> Time Taken from last point: </b> {visitModalData[0]?.time_taken_from_last_visit || "N/A"}
                                            </div>
                                            <div className="col-md-6">
                                                {/* <b> Distance from last visit :</b> {(visitModalData[0]?.distance_from_last_visit == 0 ? 0 : visitModalData[0].distance_from_last_visit) + " KM" || "N/A"} */}
                                                <b> Distance from last point :</b>{" "}
                                                {visitModalData[0]?.distance_from_last_visit === 0
                                                    ? "0 KM"
                                                    : visitModalData[0]?.distance_from_last_visit
                                                        ? `${visitModalData[0].distance_from_last_visit} KM`
                                                        : "N/A"}

                                            </div>
                                        </div>
                                        {/* <div className="row mb-2">
                                            <div className="col-12">
                                                <b> Is Decision Maker / School Authority Available For Meeting : </b> <span style={{fontWeight:"500"}}>{visitModalData[0]?.meeting_with_decision_maker?.toUpperCase() || "N/A"}</span>
                                            </div>
                                        </div> */}
                                        <div className="row mb-2">
                                            <div className="col-md-6">
                                                <b style={{ color: "black" }}>Visit Done By : </b> <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{visitModalData[0]?.u_name || "N/A"}</span>
                                            </div>
                                            <div className="col-md-6">
                                                <b style={{ color: "black" }}> Visit Type :</b>
                                                <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}> {visitModalData[0]?.typeName || "N/A"}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-md-6">
                                                <b style={{ color: "black" }}> Contact Person Name : </b>
                                                <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}> {visitModalData[0]?.ContactPerson || "N/A"}</span>
                                            </div>
                                            <div className="col-md-6">
                                                <b style={{ color: "black" }}> Contact Person Number :</b>
                                                <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}> {visitModalData[0]?.PhoneNumber || "N/A"}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-md-6">
                                                <b style={{ color: "black" }}> Visit Status : </b>
                                                <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}> {visitModalData[0]?.statusTypeName || "N/A"}</span>
                                            </div>
                                            <div className="col-md-6">
                                                <b style={{ color: "black" }}> Work Done :</b>
                                                <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}> {visitModalData[0]?.workDoneName || "N/A"}</span>
                                            </div>
                                        </div>

                                        <div className="row mb-2">
                                            <div className="col-md-6">
                                                <b style={{ color: "black" }}> Start Visit Address : </b>
                                                <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}> {visitModalData[0]?.start_address || "N/A"}</span>
                                            </div>
                                            <div className="col-md-6">
                                                <b style={{ color: "black" }}>  End Visit Address : </b>
                                                <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}> {visitModalData[0]?.end_address || "N/A"}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-md-6">
                                                <b style={{ color: "black" }}> Visit Start Remark : </b>
                                                <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}> {visitModalData[0]?.extra || "N/A"}</span>
                                            </div>
                                            <div className="col-md-6">
                                                <b>Visit End Remark : </b> {visitModalData[0]?.visitEndRemark || "N/A"}
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-md-6">
                                                <b style={{ color: "black" }}> Visit OutCome : </b>
                                                <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}> {visitModalData[0]?.name || "N/A"}</span>
                                            </div>
                                            <div className="col-md-6">
                                                <b style={{ color: "black" }}>Next Step : </b>
                                                <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{visitModalData[0]?.nextStepName || "N/A"}</span>
                                            </div>

                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-md-6">
                                                <b style={{ color: "black" }}> Follow Up Date : </b>
                                                <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}> {visitModalData[0]?.followUpDate
                                                    ? new Date(visitModalData[0].followUpDate).toLocaleDateString('en-GB')
                                                    : "N/A"}</span>

                                            </div>
                                            <div className="col-md-6">
                                                <b style={{ color: "black" }}> Follow Up Remark : </b>
                                                <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{visitModalData[0]?.followUpRemark || "N/A"}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            {/* <div className="col-md-6">
                                                <b style={{ color: "black" }}> Supervisor : </b>
                                                <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}> {visitModalData[0]?.superwisor_name || "N/A"}</span>
                                            </div> */}
                                            <div className="col-md-6">
                                                <b> Supervisor : </b> {visitModalData[0]?.reportingManagerOfTaggedUser || "N/A"}
                                            </div>
                                            <div className="col-md-6" style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <b style={{ color: "black" }}> Colleague : </b>
                                                <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}> {visitModalData[0]?.tag_user || "N/A"}</span>
                                            </div>
                                        </div>

                                        {/* <div className="row mb-2" style={{ alignItems: "center" }}>
                                            <div className="col-md-6" style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <b style={{ color: "black" }}>End Image</b>
                                                <IconButton
                                                    variant="extended"
                                                    disabled={!visitModalData[0]?.end_image}
                                                    color="primary"
                                                    onClick={e => {
                                                        e.stopPropagation();
                                                        showImages(visitModalData[0]?.end_image);
                                                    }}
                                                    sx={{ ml: 1 }}
                                                >
                                                    <RemoveRedEyeIcon />
                                                </IconButton>
                                            </div>
                                        </div> */}
                                        <div className="row mb-2">
                                            <div className="col-md-6">
                                                <b style={{ color: "black" }}> OTP Verified :</b>
                                                <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}> {visitModalData[0] && visitModalData[0]?.otp_verified == 0 ? "No" : "Yes" || "N/A"} </span>
                                            </div>
                                            <div className="col-md-6">
                                                <b style={{ color: "black" }}>  OTP Number :</b>
                                                <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}>  {visitModalData[0] && visitModalData[0]?.otp_number || "N/A"}  </span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-md-6">
                                                <b style={{ color: "black" }}>View Image</b>
                                                <IconButton
                                                    variant="extended"
                                                    disabled={!visitModalData[0]?.start_image}
                                                    color="primary"
                                                    onClick={e => {
                                                        e.stopPropagation();
                                                        showImages(visitModalData[0]?.start_image);
                                                    }}
                                                    sx={{ ml: 1 }}
                                                >
                                                    <RemoveRedEyeIcon />
                                                </IconButton>
                                            </div>
                                            <div className="col-md-6">
                                                <b style={{ color: "black" }}> Time Taken From Last Visit (In Minutes) :</b>
                                                <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}> {visitModalData[0]?.time_taken_last_visit || "N/A"}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-md-6">
                                                <b style={{ color: "black" }}> Ho Remark : </b>
                                                <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{visitModalData[0]?.ho_need_remark || "N/A"}</span>
                                            </div>
                                            <div className="col-md-6">
                                                <b style={{ color: "black" }}> Feedback : </b>
                                                <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}> {visitModalData[0]?.feedbackName || "N/A"}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            {/* <div className="col-md-6">
                                                <b style={{ color: "black" }}> Further Visit Required :</b>
                                                <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}> { "N/A" } </span>
                                            </div>
                                            <div className="col-md-6">
                                                <b style={{ color: "black" }}>  Further Visit Remark :</b>
                                                <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}>  {visitModalData[0] && visitModalData[0]?.furtherVisitRequired || "N/A"}  </span>
                                            </div> */}
                                            {(() => {
                                                const furtherVisit = visitModalData[0]?.furtherVisitRequired
                                                    ? JSON.parse(visitModalData[0]?.furtherVisitRequired)
                                                    : null;

                                                return (
                                                    <>
                                                        <div className="col-md-6">
                                                            <b style={{ color: "black" }}> Further Visit Required :</b>
                                                            <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}>
                                                                {furtherVisit
                                                                    ? furtherVisit.visit_required
                                                                        ? "Yes"
                                                                        : "No"
                                                                    : "N/A"}
                                                            </span>
                                                        </div>

                                                        <div className="col-md-6">
                                                            <b style={{ color: "black" }}> Further Visit Remark :</b>
                                                            <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}>
                                                                {furtherVisit?.reason || "N/A"}
                                                            </span>
                                                        </div>
                                                    </>
                                                );
                                            })()}

                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-12">
                                                <b style={{ color: "black" }}>   remark : </b>
                                                <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}>
                                                    {visitModalData[0]?.remarks || "N/A"}
                                                </span>
                                            </div>
                                        </div>

                                        {/* Product Category Rendering */}
                                        {/*   <div className="row mb-3 mt-1">
                      <div className="col-12">
                        <span style={{ fontWeight: "600", color: "black" }}>Product Category:</span>
                        {
                          (() => {
                            let raw = visitModalData[0]?.product_category;
                            if (!raw) return "N/A";
                            try {
                              if (typeof raw === "string") raw = JSON.parse(raw);
                              if (typeof raw === "string") raw = JSON.parse(raw);
                              if (raw && raw.interested) {
                                return (
                                  <span style={{ marginLeft: 10 }}>
                                    <div style={{ color: "black", fontWeight: 500 }}>Remark :- {raw?.interested}</div>
                                  </span>
                                );
                              }

                              let dataArr = raw?.data && Array.isArray(raw?.data) ? raw.data : [];
                              // if (!dataArr.length) return "N/A";

                              const grouped = {};
                              if (raw && raw?.interested == null) {
                                dataArr.forEach(item => {
                                  if (item && item.category) {
                                    if (!grouped[item.category]) grouped[item.category] = [];
                                    grouped[item.category].push(item);
                                  }
                                });
                                return Object.keys(grouped).map((cat, i) => {
                                  const catName = questionCategories.find(qc => String(qc.id) === String(cat))?.name || cat;
                                  return (
                                    <div key={cat} className="shadow-sm" style={{ background: "#ffffff", border: "1px solid #ddd", borderRadius: 10, padding: "15px 20px", marginBottom: 20 }}>
                                      <div style={{ color: "#1976d2", fontSize: 16, fontWeight: 700, borderBottom: "1px solid #ccc", paddingBottom: 8, marginBottom: 12 }}>
                                        Category: {catName}
                                      </div>
                                      {grouped[cat].map((item, idx) => (
                                        <div key={idx} style={{ borderBottom: idx !== grouped[cat].length - 1 ? "1px dashed #bbb" : "none", marginBottom: 10, paddingBottom: 10 }}>
                                          {Object.entries(item)
                                            .filter(([k]) => k !== "category" && k !== "title")
                                            .map(([k, v], i) => (
                                              <div key={i} style={{ marginBottom: 4 }}>
                                                <span style={{ fontWeight: 700, color: "#222" }}>{k.replace(/_/g, " ")}:</span>{" "}
                                                <span style={{ fontWeight: 400, color: "#444" }}>{v === null || v === undefined || v === "" ? "N/A" : (Array.isArray(v) ? v.join(", ") : String(v))}</span>
                                              </div>
                                            ))}
                                        </div>
                                      ))}
                                    </div>
                                  );
                                });
                              }
                            } catch (e) {
                              return "N/A";
                            }
                          })()
                        }
                      </div>
                    </div>
 */}
                                        {/* <div className="row mt-2">
                                            <div className="col-12">
                                                <span style={{ fontWeight: "600", color: "black" }}>Product Category:</span>
                                                {
                                                    (() => {
                                                        let raw = visitModalData[0]?.product_category;
                                                        if (!raw) return "N/A";
                                                        try {
                                                            if (typeof raw === "string") raw = JSON.parse(raw);
                                                            if (typeof raw === "string") raw = JSON.parse(raw);
                                                            if (raw && raw.interested) {
                                                                return (
                                                                    <span style={{ marginLeft: 10 }}>
                                                                        <div style={{ color: "black", fontWeight: 500 }}>Remark :- {raw?.interested}</div>
                                                                    </span>
                                                                );
                                                            }
                                                            let dataArr = raw?.data && Array.isArray(raw?.data) ? raw.data : [];
                                                            if (dataArr.length <= 0) return "N/A";
                                                            const grouped = {};
                                                            dataArr.forEach(item => {
                                                                console.log(item, "itemitemitemitem")
                                                                if (item && item.category) {
                                                                    if (!grouped[item.category]) grouped[item.category] = [];
                                                                    grouped[item.category].push(item);
                                                                }
                                                            });
                                                            return Object.keys(grouped).map((cat, i) => {
                                                                const catName = questionCategories.find(qc => String(qc.id) === String(cat))?.name || cat;
                                                                return (
                                                                    <div key={cat} style={{ marginLeft: 10, marginBottom: 10 }}>
                                                                        <b style={{ color: "black", fontWeight: "600", fontSize: "14px" }}>{catName}:</b>
                                                                        {grouped[cat].map((item, idx) => (
                                                                            <div key={idx} style={{ marginLeft: 20, marginBottom: 6 }}>
                                                                                <span style={{ color: "black", fontWeight: "500", fontSize: "14px" }}>
                                                                                    <b>Sub-Category:</b> {item["Sub-Category"] || "N/A"}<br />
                                                                                    <b>Products:</b> {Array.isArray(item.Product) ? item.Product.join(", ") : item.Product || "N/A"}<br />
                                                                                    <b>Any Remark:</b> {item["Any Remark"] || "N/A"}
                                                                                </span>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                );
                                                            });
                                                        } catch (e) {
                                                            return "N/A";
                                                        }
                                                    })()
                                                }
                                            </div>
                                        </div> */}
                                        <div className="row mt-4">
                                            <div className="col-12">
                                                <span style={{ fontWeight: "600", color: "black" }}>Product Category:</span>
                                                {
                                                    (() => {
                                                        let raw = visitModalData[0]?.product_category;
                                                        if (!raw) return "N/A";
                                                        try {
                                                            if (typeof raw === "string") raw = JSON.parse(raw);
                                                            if (typeof raw === "string") raw = JSON.parse(raw);

                                                            if (raw && raw.interested) {
                                                                return (
                                                                    <div className="mt-1 shadow-lg pl-4 p-2" >
                                                                        <div>
                                                                            <span style={{ fontWeight: 700, color: "#000000ff" }}> Remark :- </span><span style={{ color: "black", fontWeight: "500" }}>  {raw?.interested}</span>

                                                                        </div>
                                                                        <div style={{ color: "#444", fontWeight: 500 }}>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            }

                                                            let dataArr = raw?.data && Array.isArray(raw?.data) ? raw.data : [];
                                                            if (dataArr.length <= 0) return "N/A";

                                                            const grouped = {};
                                                            dataArr.forEach(item => {
                                                                if (item && item.category) {
                                                                    if (!grouped[item.category]) grouped[item.category] = [];
                                                                    grouped[item.category].push(item);
                                                                }
                                                            });

                                                            return Object.keys(grouped).map((cat, i) => {
                                                                const catName = questionCategories.find(qc => String(qc.id) === String(cat))?.name || cat;
                                                                return (
                                                                    <div key={cat} className="shadow-sm" style={{ background: "#ffffff", border: "1px solid #ddd", borderRadius: 10, padding: "15px 20px", marginBottom: 20 }}>
                                                                        <div style={{ color: "#1976d2", fontSize: 16, fontWeight: 700, borderBottom: "1px solid #ccc", paddingBottom: 8, marginBottom: 12 }}>
                                                                            Category: {catName}
                                                                        </div>
                                                                        {grouped[cat].map((item, idx) => (
                                                                            <div key={idx} style={{ borderBottom: idx !== grouped[cat].length - 1 ? "1px dashed #bbb" : "none", marginBottom: 10, paddingBottom: 10 }}>
                                                                                {Object.entries(item)
                                                                                    .filter(([k]) => k !== "category" && k !== "title")
                                                                                    .map(([k, v], i) => (
                                                                                        <div key={i} style={{ marginBottom: 4 }}>
                                                                                            <span style={{ fontWeight: 700, color: "black" }}>{k.replace(/_/g, " ")}:</span>{" "}
                                                                                            <span style={{ fontWeight: 500, color: "black" }}>{v === null || v === undefined || v === "" ? "N/A" : (Array.isArray(v) ? v.join(", ") : String(v))}</span>
                                                                                        </div>
                                                                                    ))}
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                );
                                                            });
                                                        } catch (e) {
                                                            return "N/A";
                                                        }
                                                    })()
                                                }
                                            </div>
                                        </div>


                                    </div>
                                    <Box mt={2} display="flex" justifyContent="flex-end">
                                        <Button onClick={handleCloseVisitViewModal} variant="contained" color="primary">
                                            Close
                                        </Button>
                                    </Box>
                                </Box>
                            </Modal>
                        </>
                    );
                },
            },
            (newOrderStatus == 1 || newOrderStatus == 2 || newOrderStatus == 3) && {
                field: "endVisit",
                headerName: "End Visit",
                width: 130,
                filterable: false,
                sortable: false,
                renderCell: (params) => {
                    return (
                        <Button
                            variant="contained"
                            color="info"
                            size="small"
                            onClick={() => endVisitDirect(params.row)}
                            sx={{ minWidth: "80px" }}
                        >
                            End Visit
                        </Button>
                    )
                },
            },
        ];
    };

    return (
        <>
            {loading && <OpaqueLoading />}
            <Dialog disableEnforceFocus maxWidth="xl" fullWidth={true} open={true} >
                <ModalHeaderContainer style={{ marginBottom: 0, paddingBottom: 1 }}>
                    <Typography variant={isMobile ? "h6" : "h5"} style={{ fontWeight: "500", color: "black" }}>
                        Today's Visit (
                        <span style={{ fontSize: isMobile ? 14 : 16, marginLeft: 12 }}>
                            {new Date().toLocaleDateString('en-GB', {
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric'
                            })}
                        </span> )
                        <Tooltip title="Order Id"></Tooltip>
                    </Typography>
                    <IconButton onClick={onClose}>
                        <CloseOutlined />
                    </IconButton>
                </ModalHeaderContainer>
                <TableContainer>
                    <TabsContainer>
                        <StyledTabs
                            variant="fullWidth"
                            value={tabValue}
                            // onChange={handleChangeTab}
                            indicatorColor="primary"
                            textColor="primary"
                        >
                            <Tab label="Today's Visit " sx={{ fontSize: "14px" }} />
                        </StyledTabs>
                        <div className="row mb-2 mt-2">
                            {/* {userData?.role.includes('admin') && <div className="col-md-3">
                                <FormControl fullWidth size="small">
                                    <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select HO</InputLabel>
                                    <Select label="Select HO" value={rsm} variant="outlined" size="small" onChange={(e) => { setRsm(e.target.value); getUsers('rsm', e.target.value); setAsm(""); setRm("") }} sx={{ width: '100%', fontSize: 14, fontWeight: "500" }}>
                                        <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                                        {rsms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.name}</MenuItem>))}
                                    </Select>
                                </FormControl>
                            </div>} */}
                            {userData?.role.includes('admin') && (
                                <div className="col-md-3">
                                    <Autocomplete
                                        options={rsms}
                                        // getOptionLabel={(option) => option.name || ""}                  
                                        getOptionLabel={(option) => option.name && option.username ? `${option.name} - ${option.username}` : option.name || option.username || ""}
                                        value={rsms.find((role) => role.id === rsm) || null}
                                        onChange={(event, value) => {
                                            setRsm(value ? value.id : "");
                                            setAsm("");
                                            setRm("");
                                            getUsers('rsm', value ? value.id : "");
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                size="small"
                                                placeholder="Select HO"
                                                InputProps={{
                                                    ...params.InputProps,
                                                    style: { color: "black", fontWeight: 500 }, // <-- This styles the input text
                                                }}
                                                InputLabelProps={{
                                                    style: { color: "black", fontWeight: 500 }, // <-- This styles the label
                                                }}
                                            />
                                        )}
                                        slotProps={{
                                            paper: {
                                                sx: { color: "black" }
                                            }
                                        }}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        sx={{ width: '100%', fontSize: 14 }}
                                    />
                                </div>
                            )}
                            {/* {userData?.role != 'asm' && <div className="col-md-3">
                                <FormControl fullWidth size="small">
                                    <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select ARM</InputLabel>
                                    <Select label="Select ARM" value={asm} variant="outlined" size="small" onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value); setRm("") }} sx={{ width: '100%', fontSize: 14, fontWeight: '500' }}>
                                        <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                                        {asms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.name}</MenuItem>))}
                                    </Select>
                                </FormControl>
                            </div>} */}
                            {userData?.role !== 'asm' && (
                                <div className="col-md-3">
                                    <Autocomplete
                                        options={asms}
                                        getOptionLabel={(option) => option.name && option.username ? `${option.name} - ${option.username}` : option.name || option.username || ""}
                                        // getOptionLabel={(option) => option.name || ""}
                                        value={asms.find((role) => role.id === asm) || null}
                                        onChange={(event, value) => {
                                            setAsm(value ? value.id : "");
                                            setRm("");
                                            getUsers('asm', value ? value.id : "");
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                size="small"
                                                placeholder="Select ARM"
                                                InputProps={{
                                                    ...params.InputProps,
                                                    style: { color: "black", fontWeight: 500 }, // <-- This styles the input text
                                                }}
                                                InputLabelProps={{
                                                    style: { color: "black", fontWeight: 500 }, // <-- This styles the label
                                                }}
                                            />
                                        )}
                                        slotProps={{
                                            paper: {
                                                sx: { color: "black" }
                                            }
                                        }}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        sx={{ width: '100%', fontSize: 14 }}
                                    />
                                </div>
                            )}
                            {/* <div className="col-md-2">
                                <FormControl fullWidth size="small">
                                    <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select RM</InputLabel>
                                    <Select label="Select RM" value={rm} variant="outlined" size="small" onChange={(e) => { setRm(e.target.value); getUsers('rm', e.target.value) }} sx={{ width: '100%', fontSize: 13, fontWeight: "500" }}>
                                        <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                                        {rms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name}</MenuItem>))}
                                    </Select>
                                </FormControl>
                            </div> */}
                            <div className="col-md-3">
                                <Autocomplete
                                    options={rms}
                                    getOptionLabel={(option) => option.name && option.username ? `${option.name} - ${option.username}` : option.name || option.username || ""}
                                    // getOptionLabel={(option) => option.name || ""}
                                    value={rms.find((role) => role.id === rm) || null}
                                    onChange={(event, value) => {
                                        setRm(value ? value.id : "");
                                        getUsers('rm', value ? value.id : "");
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            size="small"
                                            placeholder="Select RM"
                                            InputProps={{
                                                ...params.InputProps,
                                                style: { color: "black", fontWeight: 500 }, // <-- This styles the input text
                                            }}
                                            InputLabelProps={{
                                                style: { color: "black", fontWeight: 500 }, // <-- This styles the label
                                            }}
                                        />
                                    )}
                                    slotProps={{
                                        paper: {
                                            sx: { color: "black" }
                                        }
                                    }}
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    sx={{ width: '100%', fontSize: 14, color: "black" }}
                                />
                            </div>
                            <div className="col-md-1">
                                <Button variant="contained" color="primary" startIcon={<img src={searchIcon} alt="icon" height={"21"} width={"21"} />} fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => getTodayVisits()}>
                                    Find
                                </Button>
                            </div>
                           {is_download && <div className="col-md-2">
                                <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => exportOrders()}>
                                    Download
                                </Button>
                            </div>}
                        </div>
                                                     <Box
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: 1,
                                                            px: 2,
                                                            py: 1,
                                                            background: "#e8f5e9",
                                                            border: "1px solid #a5d6a7",
                                                            borderLeft: "4px solid #2e7d32",
                                                            borderRadius: "8px",
                                                            boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                                                            width: "fit-content",
                                                        }}
                                                    >
                                                        <Typography
                                                            sx={{
                                                                fontSize: "13px",
                                                                fontWeight: 600,
                                                                color: "#1b5e20",
                                                                letterSpacing: "0.3px",
                                                            }}
                                                        >
                                                            Total Entries:
                                                        </Typography>
                                                        <Typography
                                                            sx={{
                                                                fontSize: "15px",
                                                                fontWeight: 700,
                                                                color: "#2e7d32",
                                                                background: "#fff",
                                                                px: 1.2,
                                                                // py: 0.2,
                                                                borderRadius: "6px",
                                                                border: "1px solid #a5d6a7",
                                                                minWidth: "28px",
                                                                textAlign: "center",
                                                            }}
                                                        >
                                                            {rowCount || 0}
                                                        </Typography>
                                                    </Box>
                        
                        {renderContent1()}
                        {/* {tabValue == 0 && renderContent1()} */}
                    </TabsContainer>
                </TableContainer>
            </Dialog>

            <Dialog open={imageModalOpen} onClose={() => setImageModalOpen(false)} maxWidth="md">
                <DialogContent sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", p: 2, position: "relative" }}>
                    <IconButton aria-label="close" onClick={() => setImageModalOpen(false)} sx={{ position: "absolute", right: 8, top: 8, color: (theme) => theme.palette.grey[500], zIndex: 1 }}>
                        <CloseIcon />
                    </IconButton>
                    <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", minHeight: 200, minWidth: 200, }}>
                        <img src={imageUrl} alt="Attendance" style={{ maxWidth: "100%", maxHeight: "70vh", height: "auto", width: "auto", borderRadius: 8, display: "block", margin: "0 auto" }} />
                    </Box>
                </DialogContent>
            </Dialog>

            <Dialog open={endVisitModalOpen}
                //  onClose={() => { setEndVisitModalOpen(false); }}
                onClose={(event, reason) => {
                    if (reason === "backdropClick" || reason === "escapeKeyDown") return;
                    setEndVisitModalOpen(false);
                    setFollowUpDateIsReq("");
                    setIsFollowUpRemarkIsReq("");
                    setMeetingHappened("");
                    setErrors({ remark: false, followUpDate: false, followUpRemark: false });
                }}
                maxWidth="lg" fullWidth
            >
                <DialogContent>
                    <Typography variant="h6" gutterBottom sx={{ color: "black" }}>End Visit Details</Typography>
                    <Box display="flex" flexDirection="column" gap={2} mt={1}>
                        <div className="row">
                            <div className="col-md-6">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DateTimePicker
                                        sx={{ width: '100%', color: "black", fontSize: "14px", fontWeight: "500" }}
                                        label="Start Visit Time"
                                        value={endVisitRow?.startTime ? dayjs(endVisitRow.startTime) : null}
                                        disabled
                                        ampm={false}
                                    />
                                </LocalizationProvider>
                            </div>
                            <div className="col-md-6">
                                <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
                                    <InputLabel id="meeting-heppen" >Is Decision Maker / School Authority Available For Meeting ?</InputLabel>
                                    <Select
                                        labelId="meeting-heppen"
                                        disabled={endVisitRow && endVisitRow?.meeting_with_decision_maker?.toLowerCase() == "no" || endVisitRow && endVisitRow?.meeting_with_decision_maker?.toLowerCase() == "yes"}
                                        id="meeting-heppen"
                                        name="Is Decision Maker / School Authority Available For Meeting ?"
                                        value={meetingHappened}
                                        onChange={(e) => setMeetingHappened(e.target.value)}
                                        label="Is Decision Maker / School Authority Available For Meeting ?"
                                    >
                                        <MenuItem value="yes">
                                            Yes
                                        </MenuItem>
                                        <MenuItem value="no">
                                            No
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                            {/**/}
                        </div>
                        {(endVisitRow && endVisitRow?.meeting_with_decision_maker && endVisitRow?.meeting_with_decision_maker.toLowerCase() == "yes" || nextStepTrue == "yes") ? (<>

                            <div className="row">
                                <div className="col-md-6">
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DateTimePicker
                                            sx={{ width: '100%' }}
                                            label="Start Meeting Time"
                                            value={
                                                endVisitRow?.start_time_meeting
                                                    ? dayjs(endVisitRow.start_time_meeting)
                                                    : (endVisitForm.startMeetingTime ? dayjs(endVisitForm.startMeetingTime) : null)
                                            }
                                            onChange={handleStartMeetingChange}
                                            minDateTime={endVisitRow?.startTime ? dayjs(endVisitRow.startTime) : undefined}
                                            maxDateTime={endVisitRow?.startTime ? dayjs(endVisitRow.startTime).endOf('day') : undefined}
                                            shouldDisableDate={date =>
                                                endVisitRow?.startTime
                                                    ? !dayjs(date).isSame(dayjs(endVisitRow.startTime), 'day')
                                                    : false
                                            }
                                            disabled={!!endVisitRow?.start_time_meeting}
                                            ampm={false}
                                        />
                                    </LocalizationProvider>
                                </div>
                                <div className="col-md-6">
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DateTimePicker
                                            sx={{ width: '100%' }}
                                            label="End Meeting Time"
                                            value={
                                                endVisitRow?.end_time_meeting
                                                    ? dayjs(endVisitRow.end_time_meeting)
                                                    : (endVisitForm.endMeetingTime ? dayjs(endVisitForm.endMeetingTime) : null)
                                            }
                                            onChange={newValue =>
                                                setEndVisitForm(prev => ({
                                                    ...prev,
                                                    endMeetingTime: newValue ? newValue.toISOString() : "",
                                                }))
                                            }
                                            minDateTime={
                                                endVisitForm.startMeetingTime
                                                    ? dayjs(endVisitForm.startMeetingTime)
                                                    : (endVisitRow?.startTime ? dayjs(endVisitRow.startTime) : undefined)
                                            }
                                            maxDateTime={endVisitRow?.startTime ? dayjs(endVisitRow.startTime).endOf('day') : undefined}
                                            shouldDisableDate={date =>
                                                endVisitRow?.startTime
                                                    ? !dayjs(date).isSame(dayjs(endVisitRow.startTime), 'day')
                                                    : false
                                            }
                                            disabled={!!endVisitRow?.end_time_meeting}
                                            ampm={false}
                                        />
                                    </LocalizationProvider>
                                </div>

                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DateTimePicker
                                            sx={{ width: '100%' }}
                                            label="End Visit Time"
                                            value={
                                                endVisitRow?.endTime
                                                    ? dayjs(endVisitRow.endTime)
                                                    : (endVisitForm.endVisitTime ? dayjs(endVisitForm.endVisitTime) : null)
                                            }
                                            onChange={newValue =>
                                                setEndVisitForm(prev => ({
                                                    ...prev,
                                                    endVisitTime: newValue ? newValue.toISOString() : "",
                                                }))
                                            }
                                            minDateTime={
                                                endVisitForm.endMeetingTime
                                                    ? dayjs(endVisitForm.endMeetingTime)
                                                    : (endVisitForm.startMeetingTime
                                                        ? dayjs(endVisitForm.startMeetingTime)
                                                        : (endVisitRow?.startTime ? dayjs(endVisitRow.startTime) : undefined))
                                            }
                                            maxDateTime={endVisitRow?.startTime ? dayjs(endVisitRow.startTime).endOf('day') : undefined}
                                            shouldDisableDate={date =>
                                                endVisitRow?.startTime
                                                    ? !dayjs(date).isSame(dayjs(endVisitRow.startTime), 'day')
                                                    : false
                                            }
                                            disabled={!!endVisitRow?.endTime}
                                            ampm={false}
                                        />
                                    </LocalizationProvider>
                                </div>
                                <div className="col-md-6">
                                    <TextField
                                        label="Remark"
                                        name="remark"
                                        value={endVisitForm.remark}
                                        onChange={(e) => {
                                            handleEndVisitFormChange(e);
                                            if (errors.remark && e.target.value.trim()) {
                                                setErrors(prev => ({ ...prev, remark: false }));
                                            }
                                        }}
                                        fullWidth
                                        error={errors.remark}
                                        helperText={errors.remark ? "Remark is required." : ""}
                                    />

                                </div>

                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <TextField
                                        label="Contact Name"
                                        name="contactName"
                                        value={endVisitForm.contactName}
                                        onChange={handleEndVisitFormChange}
                                        fullWidth
                                    />
                                </div>
                                <div className="col-md-6">
                                    <TextField
                                        label="Mobile Number"
                                        name="mobileNumber"
                                        value={endVisitForm.mobileNumber}
                                        onChange={handleEndVisitFormChange}
                                        fullWidth
                                        type="number"
                                        onWheel={(e) => e.target.blur()} // 👈 prevents scroll wheel increment/decrement
                                        inputProps={{
                                            inputMode: 'numeric',
                                            pattern: '[0-9]*',
                                        }}
                                    />

                                </div>

                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <FormControl fullWidth style={{ width: isMobile ? "100%" : "100%" }}>
                                        <InputLabel id="status-of-visit-label">Status Of Visit</InputLabel>
                                        <Select
                                            labelId="status-of-visit-label"
                                            id="status-of-visit"
                                            name="statusOfVisit"
                                            value={endVisitForm.statusOfVisit}
                                            onChange={handleEndVisitFormChange}
                                            label="Status Of Visit"
                                        >
                                            {statusWork?.map((option) => (
                                                <MenuItem key={option.statusTypeId} value={option.statusTypeId}>
                                                    {option.statusTypeName}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col-md-6">
                                    <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
                                        <InputLabel id="work-done" >Work Done</InputLabel>
                                        <Select
                                            label="Work Done"
                                            labelId="work-done"
                                            id="work-done"
                                            name="workDone"
                                            value={endVisitForm.workDone}
                                            onChange={handleEndVisitFormChange}
                                        >
                                            {workDone?.map((option, optionIndex) => (
                                                <MenuItem key={option.workDoneTableId} value={option.workDoneTableId}>
                                                    {option.workDoneName}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl></div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
                                        <InputLabel id="feedback-label">Feedback</InputLabel>
                                        <Select
                                            labelId="feedback-label"
                                            id="feedback"
                                            name="feedback"
                                            value={endVisitForm.feedback}
                                            onChange={handleEndVisitFormChange}
                                            label="Feedback"
                                        >
                                            {feedback?.map((option) => (
                                                <MenuItem key={option.feedbackId} value={option.feedbackId}>
                                                    {option.feedbackName}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col-md-6">
                                    <FormControl fullWidth variant="outlined" disabled={loading}>
                                        <InputLabel id="visit-outcome">Select Visit Outcome</InputLabel>
                                        <Select
                                            labelId="visit-outcome"
                                            id="visit-outcome"
                                            name="visitOutcome"
                                            value={endVisitForm.visitOutcome || ''}
                                            onChange={handleEndVisitFormChange}
                                            label="Select Visit Outcome"
                                        >
                                            {visitOutcomes.length > 0 ? (
                                                visitOutcomes.map((option) => (
                                                    <MenuItem key={option.id} value={option.id}>
                                                        {option.name}
                                                    </MenuItem>
                                                ))
                                            ) : (
                                                <MenuItem disabled>{loading ? "Loading..." : "No option"}</MenuItem>
                                            )}
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                            {endVisitForm?.visitOutcome == "FpPIgxcOrY" &&
                                <div className="row">
                                    <div className="col-md-6">
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                label="Follow Up Date"
                                                value={endVisitForm.followUpDate ? dayjs(endVisitForm.followUpDate) : null}
                                                sx={{ width: "100%" }}
                                                format="YYYY/MM/DD"
                                                onChange={newValue => setEndVisitForm(prev => ({ ...prev, followUpDate: newValue ? newValue.toISOString() : "", }))}
                                                slotProps={{
                                                    textField: {
                                                        error: errors.followUpDate,
                                                        helperText: errors.followUpDate ? 'Follow Up Date is required.' : '',
                                                        fullWidth: true,
                                                    }
                                                }}
                                            />
                                        </LocalizationProvider>
                                    </div>
                                    <div className="col-md-6">
                                        <TextField
                                            label="Follow Up Remark"
                                            name="followUpRemark"
                                            value={endVisitForm.followUpRemark || ''}
                                            onChange={handleEndVisitFormChange}
                                            fullWidth
                                            multiline
                                            // minRows={2}
                                            error={errors.followUpRemark}
                                            helperText={errors.followUpRemark ? 'Follow Up Remark is required.' : ''}
                                        />
                                    </div>
                                </div>
                            }
                            <div className="row">
                                <div className="col-12">
                                    <TextField
                                        label="Visit End Remark"
                                        name="Visit End Remark"
                                        value={visitEndRemark || ''}
                                        onChange={(e) => {
                                            setVisitEndRemark(e.target.value);
                                            if (errors.visitEndRemark && e.target.value.trim()) {
                                                setErrors(prev => ({ ...prev, visitEndRemark: false }));
                                            }
                                        }}
                                        fullWidth
                                        error={errors.visitEndRemark}
                                        helperText={errors.visitEndRemark ? "Visit End Remark is required." : ""}
                                    />

                                </div>
                            </div>
                        </>)
                            : (endVisitRow && endVisitRow?.meeting_with_decision_maker && endVisitRow?.meeting_with_decision_maker.toLowerCase() == "no" || nextStepTrue == "no") && (<>
                                <div className="row">
                                    <div className="col-12">
                                        <span className="mr-5">Follow-up Required</span>
                                        <input type="checkbox"
                                            sx={{ transform: "scale(1.5)" }}
                                            // onChange={(e) => setIsFollowUpRequired(e.target.checked)} 
                                            onChange={(e) => {
                                                const checked = e.target.checked;
                                                setIsFollowUpRequired(checked);
                                                if (!checked) {
                                                    // Reset values when unchecked
                                                    setFollowUpDateIsReq("");
                                                    setIsFollowUpRemarkIsReq("");
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                {isFollowUpRequired && <div className="row">
                                    <div className="col-md-6">
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                label="Follow Up Date"
                                                value={followUpDateIsReq ? dayjs(followUpDateIsReq) : null}
                                                sx={{ width: "100%" }}
                                                format="YYYY/MM/DD"
                                                // onChange={e => setFollowUpDateIsReq(e.target.value)}
                                                onChange={newValue => setFollowUpDateIsReq(newValue ? newValue.toISOString() : "")}
                                                slotProps={{
                                                    textField: {
                                                        error: errors.followUpDateIsReq,
                                                        helperText: errors.followUpDateIsReq ? 'Follow Up Date is required.' : '',
                                                        fullWidth: true,
                                                    }
                                                }}
                                            />
                                        </LocalizationProvider>
                                        {/* } */}
                                    </div>
                                    <div className="col-md-6">
                                        <TextField
                                            label="Follow Up Remark"
                                            name="followUpRemark"
                                            value={followUpRemarkIsReq || ''}
                                            onChange={(e) => setIsFollowUpRemarkIsReq(e.target.value)}
                                            fullWidth
                                            multiline
                                            // minRows={2}
                                            error={errors.followUpRemarkIsReq}
                                            helperText={errors.followUpRemarkIsReq ? 'Follow Up Remark is required.' : ''}
                                        />
                                    </div>
                                </div>}
                                <div className="row">
                                    <div className="col-12">
                                        <TextField
                                            label="Visit End Remark"
                                            name="Visit End Remark"
                                            value={visitEndRemark || ''}
                                            onChange={(e) => {
                                                setVisitEndRemark(e.target.value);
                                                if (errors.visitEndRemark && e.target.value.trim()) {
                                                    setErrors(prev => ({ ...prev, visitEndRemark: false }));
                                                }
                                            }}
                                            fullWidth
                                            error={errors.visitEndRemark}
                                            helperText={errors.visitEndRemark ? "Visit End Remark is required." : ""}
                                        />

                                    </div>
                                </div>
                                {/* <div className="row">
                                    <div className="col-12">
                                        <TextField
                                            label="Visit End Remark"
                                            name="Visit End Remark"
                                            value={visitEndRemark || ''}
                                            onChange={(e) => {
                                                setVisitEndRemark(e.target.value);
                                                if (errors.visitEndRemark && e.target.value.trim()) {
                                                    setErrors(prev => ({ ...prev, visitEndRemark: false }));
                                                }
                                            }}
                                            fullWidth
                                            error={errors.visitEndRemark}
                                            helperText={errors.visitEndRemark ? "Visit End Remark is required." : ""}
                                        />

                                    </div>
                                </div> */}
                            </>)}
                        {/* <div className="row">
                            {endVisitForm?.visitOutcome == "FpPIgxcOrY" &&
                                <div className="col-md-12">
                                    <TextField
                                        label="Follow Up Remark"
                                        name="followUpRemark"
                                        value={endVisitForm.followUpRemark || ''}
                                        onChange={handleEndVisitFormChange}
                                        fullWidth
                                        multiline
                                        minRows={2}
                                        error={errors.followUpRemark}
                                        helperText={errors.followUpRemark ? 'Follow Up Remark is required.' : ''}
                                    />
                                </div>
                            }
                        </div> */}
                        {/* <div className="row">
                            <div className="col-12">
                                <TextField
                                    label="Visit End Remark"
                                    name="Visit End Remark"
                                    value={visitEndRemark || ''}
                                    onChange={(e) => {
                                        setVisitEndRemark(e.target.value);
                                        if (errors.visitEndRemark && e.target.value.trim()) {
                                            setErrors(prev => ({ ...prev, visitEndRemark: false }));
                                        }
                                    }}
                                    fullWidth
                                    error={errors.visitEndRemark}
                                    helperText={errors.visitEndRemark ? "Visit End Remark is required." : ""}
                                />

                            </div>
                        </div> */}

                        <Box display="flex" justifyContent="flex-end" gap={2}>
                            <Button onClick={() => {
                                setEndVisitModalOpen(false);
                                setIsFollowUpRequired(false);
                                setFollowUpDateIsReq("");
                                setMeetingHappened("");
                                setIsFollowUpRemarkIsReq("");
                                setVisitEndRemark("");
                                setErrors({ remark: false, followUpDate: false, followUpRemark: false });
                            }} variant="outlined">Cancel</Button>
                            {((endVisitRow && endVisitRow?.meeting_with_decision_maker && endVisitRow?.meeting_with_decision_maker.toLowerCase() == "yes") || (endVisitRow && endVisitRow?.meeting_with_decision_maker && endVisitRow?.meeting_with_decision_maker.toLowerCase() == "no")) && <Button variant="contained" onClick={handleEndVisitSubmit}>Submit</Button>}
                            {!(endVisitRow && endVisitRow?.meeting_with_decision_maker) && <Button color="success" variant="contained" onClick={updateMeetingWithDecisionMaker()}>Submit</Button>}
                        </Box>
                    </Box>
                </DialogContent>
            </Dialog>

        </>
    );
};
export default TodayVisitModal;